// extracted by mini-css-extract-plugin
module.exports = {"common-card-title":"IndexPage_common-card-title__1DNC5","column-flex":"IndexPage_column-flex__1FiKZ","IndexPage":"IndexPage_IndexPage__2YNlN"};